export default "__VITE_ASSET__91EuiyAR__"